import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, ReplaySubject } from 'rxjs';
import { Calendar } from '../../models/calendar';
import { DatewiseEvents } from '../../models/datewise-events';
import { DatePipe } from '@angular/common';
import { AppSettings } from '../../../../../utils/app-settings';
import { DateUtils } from '../../../../../utils/date-utils';

@Injectable({
  providedIn: 'root'
})
export class EventsService {
  private _events: ReplaySubject<Calendar> = new ReplaySubject<Calendar>(1);
  private events$ = this._events.asObservable();
  private _schedule: ReplaySubject<Array<DatewiseEvents>> = new ReplaySubject<Array<DatewiseEvents>>(1);
  private schedule$ = this._schedule.asObservable();
  private calendar: Calendar;
  private weeks: Array<Array<DatewiseEvents>>;
  private _weeks: ReplaySubject<Array<Array<DatewiseEvents>>> = new ReplaySubject<Array<Array<DatewiseEvents>>>(1);
  private currentDate: Date = new Date("1 1, 0100");
  public weeks$ = this._weeks.asObservable();

  constructor(private http: HttpClient, private datepipe: DatePipe) { }

  private http_events_fetched = false;
  private http_schedule_fetched = false;

  getEvents(): Observable<Calendar> {
    if (!this.http_events_fetched) {
      this.http_events_fetched = true;
      this.http.get<Calendar>(AppSettings.apiUrl + "events")
        .subscribe(res => {
          this._events.next(res);
        }, error => {
          this.http_events_fetched = false;
          console.error(error);
        });
    }
    return this.events$;
  }

  getEventsForMonth(date: Date) {
    if (this.currentDate.getMonth() != date.getMonth() || this.currentDate.getFullYear() != date.getFullYear()) {
      this.currentDate = new Date(date);
      this.currentDate.setDate(1);
      let start_date = DateUtils.getStartDateForMonthView(this.currentDate);
      let end_date = new Date(start_date);
      end_date.setDate(end_date.getDate() + 41);
      let strStartDate = this.datepipe.transform(start_date, "yyyy-MM-dd");
      let strEndDate = this.datepipe.transform(end_date, "yyyy-MM-dd");
      this.http.get<Calendar>(AppSettings.apiUrl + "events/GetByDateRange?startDate=" + strStartDate + "&endDate=" + strEndDate)
        .subscribe(res => {
          this.calendar = res;
          this.generateCalendar();
          this._weeks.next(this.weeks);
        });
    }
    else {
      this._weeks.next(this.weeks);
    }
  }

  generateCalendar() {
    var weeks = [];
    while (this.calendar.datewise_events.length > 0) {
      weeks.push(this.calendar.datewise_events.splice(0, 7));
    }
    this.weeks = weeks;
  }

  getEventsForAccademicYear(): Observable<Array<DatewiseEvents>> {
    if (!this.http_schedule_fetched) {
      this.http_schedule_fetched = true;
      this.http.get<Array<DatewiseEvents>>(AppSettings.apiUrl + "events/GetEventsForCurrentAccademicYear")
        .subscribe(res => {
          this._schedule.next(res);
        }, error => {
          console.error(error);
        });
    }
    return this.schedule$;
  }

  
  getJoinUrlForMobile(eventOccurenceId: number): Observable<string> {
    return this.http.get<string>(`${AppSettings.apiUrl}Events/${eventOccurenceId}/meetingurl`);
  }
}
